<template>
  <v-container>
    <v-row>
      <v-col align="right">
        <TextButton @click="openRegistrarNuevaLicencia"> REGISTRAR LICENCIA </TextButton>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary" :loading="loading">
          <v-card-text>
            <v-data-table :headers="headers" :items="locs" class="transparent">
              <template v-slot:[`item.opciones`]="{ item }">
                <span class="d-flex align-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <IconButton
                          class="mr-2"
                          variant="secondary"
                          icon="mdi-card-account-details-outline"
                          @click="openVerDetalleLicencia(item)"
                        />
                      </span>
                    </template>
                    <span>Ver detalle</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <IconButton variant="secondary" icon="mdi-pencil" @click="openEditarLicencia(item)" />
                      </span>
                    </template>
                    <span>Editar Licencia</span>
                  </v-tooltip>
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'
import IconButton from '@src/components/base/IconButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  components: {
    TextButton,
    IconButton,
  },
  data() {
    return {
      headers: [
        { text: 'Numero de Oficio', value: 'numeroOficio', width: '10%' },
        { text: 'Numero de Licencia', value: 'noLicencia', width: '10%' },
        { text: 'Representante legal', value: 'representanteLegal', width: '10%' },
        { text: 'Titular', value: 'titular', width: '10%' },
        { text: 'Vigencia', value: 'vigencia', width: '10%' },
        { text: 'Fecha de alta', value: 'fechaAlta', width: '10%' },
        { text: 'Fecha de tramite', value: 'fechaTramite', width: '10%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
      loading: false,
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('licenciaOficialColectiva', {
      locsOriginal: 'getLocs',
    }),
    ...mapGetters('remesas', {
      remesas: 'getRemesas',
    }),
    locs() {
      return this.locsOriginal.map((loc) => ({
        ...loc,
        fechaAlta: loc.fechaAlta
          ? moment(loc.fechaAlta, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).isValid()
            ? moment(loc.fechaAlta, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
            : 'Fecha inválida'
          : '',
        fechaTramite: loc.fechaTramite
          ? moment(loc.fechaTramite, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).isValid()
            ? moment(loc.fechaTramite, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
            : 'Fecha inválida'
          : '',
      }))
    },
  },
  methods: {
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    ...mapActions('remesas', {
      fetchRemesas: 'fetchRemesas',
    }),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('licenciaOficialColectiva', ['SET_SELECTED_LOC']),
    ...mapMutations('remesas', ['SET_SELECTED_REMESA']),

    openRegistrarNuevaLicencia() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_NUEVA_LICENCIA_OFICIAL_COLECTIVA)
    },
    openVerDetalleLicencia(licenciaOficialColectiva) {
      this.SET_SELECTED_LOC(licenciaOficialColectiva)
      this.SET_DIALOG(DIALOG_TYPES.MOSTRAR_DETALLE_LICENCIA_OFICIAL_COLECTIVA)
    },
    openEditarLicencia(licenciaOficialColectiva) {
      this.SET_SELECTED_LOC(licenciaOficialColectiva)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_LICENCIA_OFICIAL_COLECTIVA)
    },
  },
  created() {
    this.fetchLocs()
    this.fetchRemesas()
  },
}
</script>

<style scoped>
/* Estilos modernos para LicenciaOficialColectivaTabContent */
.card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 48px rgba(108, 92, 231, 0.3);
  border-color: rgba(108, 92, 231, 0.4);
}

/* Título */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
}

::v-deep .v-data-table__wrapper {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(108, 92, 231, 0.15) 0%, rgba(108, 92, 231, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.2s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.12) !important;
  transform: scale(1.005);
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.08) !important;
  padding: 14px 16px !important;
  font-size: 0.9375rem;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
  transform: scale(1.1);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #e0e0e0 !important;
}

/* Loading state */
::v-deep .v-progress-linear {
  border-radius: 8px;
}

::v-deep .v-progress-linear__background {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-progress-linear__determinate {
  background: linear-gradient(90deg, #6c5ce7 0%, #a29bfe 100%) !important;
  box-shadow: 0 0 12px rgba(108, 92, 231, 0.5);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
